import { Component, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SelectedFilterField } from '@cdw-ae/filter-bar-interfaces';
import { Observable } from 'rxjs';

@Component({
  template: ' <p>baseMatcherEditorComponent class</p> ',
  styles: ['mat-form-field { width: 100%; }'],
  standalone: false,
})
export class BaseMatcherEditorComponent {
  public matcherDisplayName!: string;

  public matcherName!: string;

  public state!: FormGroup;

  @Input()
  public matcherOptions!: SelectedFilterField;

  @Output()
  public valueToMatch!:
    | string
    | number
    | { operator: string; value: string | number }
    | null;

  @Output()
  public hasErrors$!: Observable<boolean | null>;

  public validate$?: () => Observable<void>;
}
